import { render, staticRenderFns } from "./PaymentBillAddi.vue?vue&type=template&id=30b5e4a0&"
import script from "./PaymentBillAddi.vue?vue&type=script&lang=js&"
export * from "./PaymentBillAddi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports